import { render, staticRenderFns } from "./AddToHomeScreenBtn.vue?vue&type=template&id=32a0fd6b&scoped=true"
import script from "./AddToHomeScreenBtn.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreenBtn.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreenBtn.vue?vue&type=style&index=0&id=32a0fd6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0fd6b",
  null
  
)

export default component.exports